import type { $Fetch } from 'ofetch';
import type { DisciplineCompositionGateway } from '@/application/port/out/DisciplineCompositionGateway';
import type { DisciplineResourceLink, DisciplineResourceReference, DisciplineResourceMutation } from '@/domain/model/DisciplineComposition';
import type { Unidade } from '@/domain/model/ConteudoExterno';
import type { Avaliacao } from '@/domain/model/Avaliacao';
import type { Questao } from '@/domain/model/Questao';
import type { ApiResponse } from './types';
import { assertApiSuccess } from './assertApiSuccess';
interface UnitLink { unitId: string; orderIndex: number; unit: Unidade }
interface AssessmentLink { assessmentId: string; orderIndex: number; assessment: Avaliacao }
interface QuestionLink { questionId: string; question: Questao }
function base(reference: DisciplineResourceReference): string { return `/api/v1/disciplines/${encodeURIComponent(reference.disciplineId)}/${reference.kind}`; }
export class HttpDisciplineCompositionGateway implements DisciplineCompositionGateway {
 constructor(private readonly client: $Fetch) {}
 async list(reference: DisciplineResourceReference): Promise<DisciplineResourceLink[]> {
  if (reference.kind === 'unidades') {
   const response = await this.client<ApiResponse<UnitLink[]>>(base(reference)); assertApiSuccess(response);
   return response.data.map(link => ({ resourceId: link.unitId, orderIndex: link.orderIndex, title: link.unit.nome, status: link.unit.ativo ? 'Ativa' : 'Inativa' }));
  }
  if (reference.kind === 'avaliacoes') {
   const response = await this.client<ApiResponse<AssessmentLink[]>>(base(reference)); assertApiSuccess(response);
   return response.data.map(link => ({ resourceId: link.assessmentId, orderIndex: link.orderIndex, title: link.assessment.titulo, status: link.assessment.status }));
  }
  const response = await this.client<ApiResponse<QuestionLink[]>>(base(reference)); assertApiSuccess(response);
  return response.data.map(link => ({ resourceId: link.questionId, orderIndex: null, title: link.question.enunciado, status: 'Disponível' }));
 }
 async add(command: DisciplineResourceMutation): Promise<void> { await this.save(command, 'POST'); }
 async reorder(command: DisciplineResourceMutation): Promise<void> { await this.save(command, 'PUT'); }
 private async save(command: DisciplineResourceMutation, method: 'POST' | 'PUT'): Promise<void> {
  const response = await this.client<ApiResponse<unknown>>(`${base(command)}/${encodeURIComponent(command.resourceId)}`, { method, ...(command.kind === 'questoes' ? {} : { body: { orderIndex: command.orderIndex } }) });
  assertApiSuccess(response);
 }
 async remove(command: DisciplineResourceMutation): Promise<void> { await this.client<void>(`${base(command)}/${encodeURIComponent(command.resourceId)}`, { method: 'DELETE' }); }
}
